import React, { useEffect, useState } from 'react';
import { MDBPagination, MDBPaginationItem, MDBPaginationLink } from 'mdb-react-ui-kit';

const Pagination = ({ currentPage, totalPages, onPageChange, totalRecords , onRowsPerPageChange , itemsPerPage}) => {
    const [customPage, setCustomPage] = useState(currentPage);
    const [rowsPerPage , setRowsPerPage] = useState(parseInt(itemsPerPage));

    const renderPaginationInfo = () => {
        const startRecord = (currentPage - 1) * rowsPerPage + 1;
        const startRecordS = (currentPage - 1) * rowsPerPage + rowsPerPage;
        const endRecord = Math.min(currentPage * rowsPerPage, totalRecords);
        return `Showing ${startRecord}-${startRecordS <= totalRecords ? startRecordS : totalRecords} of ${totalRecords} records`;
    };

    const renderPaginationItems = () => {
        const paginationItems = [];
        const visiblePages = 4; // Number of pages to display in the pagination

        // Option to move to the first page
        if (currentPage !== 1 && totalPages > 3) {
            paginationItems.push(
                <MDBPaginationItem key="first" active={currentPage === 1}>
                    <MDBPaginationLink onClick={() => onPageChange(1)}>&laquo;&laquo;</MDBPaginationLink>
                </MDBPaginationItem>
            );
        }

        // Option to move to the previous page
        paginationItems.push(
            <MDBPaginationItem disabled={currentPage === 1} key="previous">
                <MDBPaginationLink onClick={() => onPageChange(currentPage - 1)} aria-label='Previous'>
                    <span aria-hidden='true'>&laquo;</span>
                </MDBPaginationLink>
            </MDBPaginationItem>
        );

        // Display dynamic range of page numbers
        const start = Math.max(1, currentPage - Math.floor(visiblePages / 2));
        const end = Math.min(start + visiblePages - 1, totalPages);

        for (let pageNumber = start; pageNumber <= end; pageNumber++) {
            paginationItems.push(
                <MDBPaginationItem key={pageNumber} active={pageNumber === currentPage}>
                    <MDBPaginationLink onClick={() => onPageChange(pageNumber)}>{pageNumber}</MDBPaginationLink>
                </MDBPaginationItem>
            );
        }

        // Option to move to the next page
        paginationItems.push(
            <MDBPaginationItem disabled={currentPage === totalPages} key="next">
                <MDBPaginationLink onClick={() => onPageChange(currentPage + 1)} aria-label='Next'>
                    <span aria-hidden='true'>&raquo;</span>
                </MDBPaginationLink>
            </MDBPaginationItem>
        );
        if (end < totalPages) {
            // Option to move to the last page
            paginationItems.push(
                <MDBPaginationItem key="last" active={currentPage === totalPages}>
                    <MDBPaginationLink onClick={() => onPageChange(totalPages)}>&raquo;&raquo;</MDBPaginationLink>
                </MDBPaginationItem>
            );
        }

        return paginationItems;
    };
    useEffect(() => {
        if (currentPage < totalPages) {
            setCustomPage(currentPage+1);
        } else{
            setCustomPage(currentPage);
        }
    }, [currentPage])

    const handleCustomPageChange = () => {
        const pageNumber = parseInt(customPage, 10);
        if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= totalPages) {
            onPageChange(pageNumber);
        }
    };

    const handleRowsPerPageChange = (size) => {
        setRowsPerPage(size);
        onRowsPerPageChange(size);
    }

    return (
        <div className='row pagination-item' style={{ display: 'flex', alignItems: 'center',padding: "5px",
        borderTop: "2px solid #e3e1e1", fontSize: "14px" }}>
            <div className='mt-3 col-md-6 col-sm-12 row'>
                <div className='col-lg-6 col-md-12 col-sm-12 mb-3 pagination-pills' style={{textAlign:"center",display: "inline-grid"}}>
                    <label htmlFor="paginationInfo" style={{marginRight : '10px'}}><small>{renderPaginationInfo()}</small></label>
                </div>
                <div className='col-lg-6 col-md-12 col-sm-12 jump-to-page' style={{textAlign:"center"}}>
                    <label htmlFor="customPage"><small>Jump to Page : </small></label>
                    <input
                        id="customPage"
                        type="text"
                        className="form-control form-control-sm ml-1"
                        value={customPage}
                        onChange={(e) => setCustomPage(e.target.value)}
                        style={{ width: "3rem", display: 'inline-block', marginLeft: '5px' }}
                    />
                    <button className="btn btn-primary btn-sm" style={{ marginLeft: '5px', marginRight: '10px' }} onClick={handleCustomPageChange}>Go</button>
                </div>
            </div>
            <div className='mt-3 col-md-6 col-sm-12 row page-items' style={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                <div className='col-lg-6 col-md-12 col-sm-12 row-per-page' style={{textAlign:"center"}}>
                    <label htmlFor='totalRecords'>
                        <small>Rows per page : </small>
                        <select className='custom-select custom-select-sm form-control form-control-sm ml-1' id="totalRecords" onChange={(event) => handleRowsPerPageChange(parseInt(event.target.value))} name="totalRecords" style={{ display: 'inline-block', width: 'auto' }} defaultValue={10}>
                            <option value="10">10</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="200">200</option>
                        </select>
                    </label>
                </div>
                <div className='col-lg-6 col-md-12 col-sm-12' style={{textAlign:"center", display:"contents"}}>
                    <nav aria-label='Page navigation example' style={{ marginLeft: '10px' , marginRight : '10px'}}>
                        <MDBPagination className='mb-0'>
                            {renderPaginationItems()}
                        </MDBPagination>
                    </nav>
                </div>
                
            </div>

        </div >
    );
};

export default Pagination;
